// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes shimmer-loading--mGMi1{0%{background-position:200% 0}100%{background-position:-200% 0}}.progress-bar.progress-bar--minimal--Z2BVE{background-color:#d7dae4;height:10px;border-radius:10px}.progress-bar .progress-bar--minimal__fill--jC3kg{background-color:#aaa2fa;height:100%}.progress-bar .progress-bar__fill--animated--xjwJF{transition:width 1s cubic-bezier(0.18, 0.1, 0.18, 1)}.progress-bar.full-width-progress--QLUnY.progress{width:100%;margin:auto}.progress-bar.progress-bar-striped{background-color:#5645f5;height:100%}.progress-bar.grey--nZudt{background-color:#fafafb}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"progress-bar--minimal": "progress-bar--minimal--Z2BVE",
	"progress-bar--minimal__fill": "progress-bar--minimal__fill--jC3kg",
	"progress-bar__fill--animated": "progress-bar__fill--animated--xjwJF",
	"full-width-progress": "full-width-progress--QLUnY",
	"grey": "grey--nZudt",
	"shimmer-loading": "shimmer-loading--mGMi1"
};
export default ___CSS_LOADER_EXPORT___;
